import { render, staticRenderFns } from "./BaseBreadcrumb.vue?vue&type=template&id=d4877086"
import script from "./BaseBreadcrumb.vue?vue&type=script&lang=js"
export * from "./BaseBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./BaseBreadcrumb.vue?vue&type=style&index=0&id=d4877086&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../PO_APP_Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports